import PropTypes from 'prop-types'
import { Linker } from '@/components/content/linker'

TextCTA.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  icon: PropTypes.string,
  type: PropTypes.string.isRequired,
  style: PropTypes.string,
  size: PropTypes.string,
  classes: PropTypes.string,
  theme: PropTypes.string,
}

export function TextCTA(props: { title: string; url: string; icon: string; type: string; style: string; size: string; theme: string; }) {

  const { title, url, icon, type, style, size, theme } = props
  // console.log({theme})
  function StyleClasses(style: string, theme: string) {
    if (theme === 'light') {
      return 'text-gray-900 underline hover:no-underline'
    } else if (theme === 'dark') {
      return 'text-white underline hover:no-underline'
    } else {
      return 'text-gray-900 underline hover:no-underline'
    }
  }

  function SizeClasses(size: string) {
    if (size === 'lg') {
      return 'font-medium text-base lg:text-lg'
    } else if (size === 'sm') {
      return 'font-medium text-sm lg:text-base'
    } else {
      return null
    }
  }

  return (
    <p>
      <Linker url={url} classes={`${SizeClasses(size)}
      ${StyleClasses(style, theme)}`}>{title}</Linker>
    </p>
  )
}
